module.exports = __webpack_public_path__ + "static/img/cont49 (2).f993670.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont49 (2).jpg
// module id = Sk9E
// module chunks = 0